<img role="presentation"
     auto="none"
     [use]="card"
     [query]="{ width: 125, height:75,  }"
     *ngFor="let card of menu?.footerMedias">
